import { FC } from 'react';
import { HighlightMatches } from './HighlightMatches';

export const SearchResultOptionLabel: FC<{
  title: string;
  description?: string;
  query?: string;
}> = ({ title, description, query }) => (
  <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
    <div>
      <HighlightMatches text={title} query={query ?? ''} />
    </div>
    {description && (
      <div
        style={{
          fontSize: '12px',
          color: 'rgba(0, 0, 0, 0.45)',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
        }}
      >
        <HighlightMatches text={description} query={query ?? ''} />
      </div>
    )}
  </div>
);
